/* ============================================================
   Re-Coco — Product Detail JS
   Handles: variant selection, qty, tabs, add to cart, buy now
   ============================================================ */

(function () {
  'use strict';

  function init() {

    // ── Variant selector ─────────────────────────────────────
    document.querySelectorAll('[data-variant-btn]').forEach(btn => {
      btn.addEventListener('click', () => {
        document.querySelectorAll('[data-variant-btn]').forEach(b => {
          b.classList.remove('border-primary-dark', 'bg-primary-dark', 'text-white');
          b.classList.add('border-border-light', 'text-text-dark');
        });
        btn.classList.add('border-primary-dark', 'bg-primary-dark', 'text-white');
        btn.classList.remove('border-border-light', 'text-text-dark');

        const price        = btn.dataset.variantPrice;
        const comparePrice = btn.dataset.variantComparePrice;
        const variantId    = btn.dataset.variantId;

        // ── Update displayed price ──────────────────────────
        const priceEl = document.getElementById('product-price');
        if (priceEl && price) priceEl.textContent = '\u20B9' + price;

        // ── Update compare-at price & discount badge ────────
        const comparePriceRow = document.getElementById('product-compare-price-row');
        const compareEl       = document.getElementById('product-compare-price');
        const discountEl      = document.getElementById('product-discount-badge');
        if (comparePriceRow && compareEl && discountEl) {
          const priceParsed   = parseFloat((price || '0').replace(/,/g, ''));
          const compareParsed = parseFloat((comparePrice || '0').replace(/,/g, ''));
          if (comparePrice && compareParsed > priceParsed) {
            compareEl.textContent = '\u20B9' + comparePrice;
            comparePriceRow.classList.remove('hidden');
            const pct = Math.floor((compareParsed - priceParsed) * 100 / compareParsed);
            discountEl.textContent = pct + '% OFF';
          } else {
            comparePriceRow.classList.add('hidden');
          }
        }

        // ── Update Add to Cart variant id ──────────────────
        const addBtn = document.getElementById('add-to-cart-btn');
        if (addBtn && variantId) {
          addBtn.dataset.addToCart = variantId;
        }

        // ── Keep wishlist metadata aligned with selected variant
        const wishlistBtn = document.querySelector('[data-wishlist-toggle]');
        if (wishlistBtn) {
          wishlistBtn.dataset.productPrice        = price || wishlistBtn.dataset.productPrice || '';
          wishlistBtn.dataset.productComparePrice = comparePrice || '';
          wishlistBtn.dataset.productVariantId    = variantId || wishlistBtn.dataset.productVariantId || '';
        }

        // ── Update Main Image ──────────────────────────────────
        const variantImage = btn.dataset.variantImage;
        const mainImg = document.getElementById('main-product-img');
        if (mainImg && variantImage) {
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = variantImage;
        }
        
        // Hide engraving overlay when switching variants
        const previewOverlay = document.getElementById('engraving-preview-overlay');
        if (previewOverlay) {
          previewOverlay.style.display = 'none';
        }

        // ── Reset Customizations ─────────────────────────────────
        const engravingCheckbox = document.getElementById('gift-engraving-checkbox');
        const wrapCheckbox = document.getElementById('gift-wrap-checkbox');
        const engravingText = document.getElementById('engraving-text');
        
        if (engravingCheckbox) {
          engravingCheckbox.checked = false;
          // Trigger change event to hide the text box and clear preview
          engravingCheckbox.dispatchEvent(new Event('change'));
        }
        if (wrapCheckbox) {
          wrapCheckbox.checked = false;
          wrapCheckbox.dispatchEvent(new Event('change'));
        }
        if (engravingText) {
          engravingText.value = '';
          engravingText.dispatchEvent(new Event('input'));
        }

        const totalEl = document.getElementById('qty-total-price');
        if (totalEl && price) {
          totalEl.dataset.unitPrice = Math.round(parseFloat(price.replace(/,/g, '')) * 100);
          const currentQty = parseInt(document.getElementById('qty-display') ? document.getElementById('qty-display').textContent : '1');
          updateTotalPrice(currentQty);
        }
      });
    });

    // ── Quantity selector ────────────────────────────────────
    const qtyContainer = document.getElementById('product-qty-container');
    const step = qtyContainer ? parseInt(qtyContainer.dataset.qtyStep || '1') : 1;
    const minQty = qtyContainer && qtyContainer.dataset.minQty ? parseInt(qtyContainer.dataset.minQty) : step;
    const maxQty = qtyContainer && qtyContainer.dataset.maxQty !== 'null' ? parseInt(qtyContainer.dataset.maxQty) : Infinity;

    const qtyDisplay = document.getElementById('qty-display');
    const qtyMinus   = document.getElementById('qty-minus');
    const qtyPlus    = document.getElementById('qty-plus');

    if (qtyMinus) qtyMinus.addEventListener('click', () => {
      let q = parseInt(qtyDisplay.textContent);
      if (q > minQty) { 
        q -= step; 
        if (q < minQty) q = minQty;
        qtyDisplay.textContent = q; 
      }
      updateQtyOnAddBtn(q);
      updateTotalPrice(q);
      updateActivePackBtn(q);
    });
    if (qtyPlus) qtyPlus.addEventListener('click', () => {
      let q = parseInt(qtyDisplay.textContent);
      if (q + step <= maxQty) {
        q += step;
        qtyDisplay.textContent = q;
        updateQtyOnAddBtn(q);
        updateTotalPrice(q);
        updateActivePackBtn(q);
      }
    });

    function updateActivePackBtn(q) {
      document.querySelectorAll('.pack-btn').forEach(btn => {
        if (parseInt(btn.dataset.packQty) === q) {
          btn.classList.add('border-primary-dark', 'bg-primary-dark/10', 'text-primary-dark');
          btn.classList.remove('border-border-light', 'text-text-dark');
        } else {
          btn.classList.remove('border-primary-dark', 'bg-primary-dark/10', 'text-primary-dark');
          btn.classList.add('border-border-light', 'text-text-dark');
        }
      });
    }

    // ── Pack Buttons logic ───────────────────────────────────
    document.querySelectorAll('.pack-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        let q = parseInt(btn.dataset.packQty);
        if (qtyDisplay) qtyDisplay.textContent = q;
        updateQtyOnAddBtn(q);
        updateTotalPrice(q);
        updateActivePackBtn(q);
      });
    });

    // Initialize active pack button & total price on page load
    const initialQty = parseInt(qtyDisplay ? qtyDisplay.textContent : (minQty || '1'));
    if (initialQty) {
      updateActivePackBtn(initialQty);
      updateTotalPrice(initialQty);
      updateQtyOnAddBtn(initialQty);
    }

    function updateQtyOnAddBtn(q) {
      const btn = document.getElementById('add-to-cart-btn');
      if (btn) btn.dataset.qty = q;
    }

    function updateTotalPrice(qty) {
      const totalEl = document.getElementById('qty-total-price');
      const unitLabel = document.getElementById('qty-unit-label');
      if (!totalEl) return;

      const unitPrice = parseInt(totalEl.dataset.unitPrice || 0);
      let discountPct = 0;
      
      const qtyContainer = document.getElementById('product-qty-container');
      const step = qtyContainer ? parseInt(qtyContainer.dataset.qtyStep || '1') : 1;
      const numPacks = qty / step;
      const discountTier1 = qtyContainer && qtyContainer.dataset.discount1 ? parseInt(qtyContainer.dataset.discount1) : 10;
      const discountTier2 = qtyContainer && qtyContainer.dataset.discount2 ? parseInt(qtyContainer.dataset.discount2) : 15;

      if (numPacks >= 5) {
        discountPct = discountTier2 / 100;
      } else if (numPacks >= 3) {
        discountPct = discountTier1 / 100;
      }

      const discountedUnitPrice = unitPrice * (1 - discountPct);
      const total = discountedUnitPrice * qty;

      // Format as Indian Rupees
      const formatted = '₹' + (total / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const unitFormatted = '₹' + (discountedUnitPrice / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

      totalEl.textContent = formatted;
      if (unitLabel) {
        if (discountPct > 0) {
          unitLabel.innerHTML = `<span class="bg-primary-tan text-white px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wide inline-block mb-1">Save ${discountPct * 100}%</span><br><span class="font-bold text-text-dark text-sm">` + qty + ' × ' + unitFormatted + ` each</span><br><span class="text-primary-tan font-medium">You save ₹${((unitPrice * qty - total) / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>`;
        } else {
          unitLabel.textContent = qty + ' × ' + unitFormatted;
        }
      }

      // Update main product price UI
      const mainPriceEl = document.getElementById('product-price');
      const comparePriceRow = document.getElementById('product-compare-price-row');
      const compareEl = document.getElementById('product-compare-price');
      const discountEl = document.getElementById('product-discount-badge');

      if (mainPriceEl) {
        mainPriceEl.textContent = unitFormatted;
      }
      
      if (comparePriceRow && compareEl && discountEl) {
        if (discountPct > 0) {
          const originalFormatted = '₹' + (unitPrice / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          compareEl.textContent = originalFormatted;
          comparePriceRow.classList.remove('hidden');
          discountEl.textContent = `${discountPct * 100}% OFF`;
        } else {
          // Revert to variant logic if no quantity discount
          const activeVariantBtn = document.querySelector('[data-variant-btn].bg-primary-dark');
          if (activeVariantBtn) {
            const variantComparePrice = activeVariantBtn.dataset.variantComparePrice;
            const variantPrice = activeVariantBtn.dataset.variantPrice;
            if (variantComparePrice && parseFloat(variantComparePrice.replace(/,/g, '')) > parseFloat((variantPrice || '0').replace(/,/g, ''))) {
              compareEl.textContent = '₹' + variantComparePrice;
              comparePriceRow.classList.remove('hidden');
              const priceParsed = parseFloat((variantPrice || '0').replace(/,/g, ''));
              const compareParsed = parseFloat(variantComparePrice.replace(/,/g, ''));
              const pct = Math.floor((compareParsed - priceParsed) * 100 / compareParsed);
              discountEl.textContent = pct + '% OFF';
            } else {
              comparePriceRow.classList.add('hidden');
            }
          } else {
            comparePriceRow.classList.add('hidden');
          }
        }
      }

      // Update progress banner
      const banner = document.getElementById('product-discount-banner');
      if (banner) {
        if (numPacks >= 5) {
          banner.innerHTML = '🎉 <span class="font-bold">Best Offer!</span> You unlocked <span class="font-bold">' + discountTier2 + '% OFF</span>';
          banner.className = 'mt-3 p-3 bg-green-50 text-green-800 border border-green-200 rounded-xl text-sm text-center transition-all';
        } else if (numPacks >= 3) {
          banner.innerHTML = '🎊 <span class="font-bold">Congratulations!</span> You unlocked <span class="font-bold">' + discountTier1 + '% OFF</span>.<br><span class="text-xs">Add ' + (5 - numPacks) + ' more for ' + discountTier2 + '% OFF!</span>';
          banner.className = 'mt-3 p-3 bg-green-50 text-green-800 border border-green-200 rounded-xl text-sm text-center transition-all';
        } else {
          banner.innerHTML = 'Buy ' + (3 - numPacks) + ' more item' + ((3 - numPacks) > 1 ? 's' : '') + ' to save <span class="font-bold">' + discountTier1 + '%</span>!';
          banner.className = 'mt-3 p-3 bg-orange-50 text-orange-800 border border-orange-200 rounded-xl text-sm text-center transition-all';
        }
      }
    }

    // Keep total in sync when variant changes
    document.querySelectorAll('[data-variant-btn]').forEach(btn => {
      btn.addEventListener('click', () => {
        const totalEl = document.getElementById('qty-total-price');
        if (totalEl && btn.dataset.variantPrice) {
          // variantPrice is without currency (e.g. "250.00"), convert to paise
          const priceInPaise = Math.round(parseFloat(btn.dataset.variantPrice.replace(/,/g, '')) * 100);
          totalEl.dataset.unitPrice = priceInPaise;
          const qty = parseInt(document.getElementById('qty-display')?.textContent || 1);
          updateTotalPrice(qty);
        }
      });
    });

    // Combo tier selection
    window.selectComboTier = function(btn) {
      const qty   = parseInt(btn.dataset.comboQty || 1);
      const price = parseFloat(btn.dataset.comboPrice || 0);

      // Highlight selected tier
      document.querySelectorAll('.combo-tier-btn').forEach(b => {
        b.classList.remove('bg-primary-dark/10', 'border-l-4', 'border-primary-dark');
      });
      btn.classList.add('bg-primary-dark/10', 'border-l-4', 'border-primary-dark');

      // Update quantity
      if (qtyDisplay) qtyDisplay.textContent = qty;
      updateQtyOnAddBtn(qty);

      // Update total display directly with combo price
      const totalEl = document.getElementById('qty-total-price');
      const unitLabel = document.getElementById('qty-unit-label');
      if (totalEl) {
        totalEl.textContent = '₹' + price.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        // Store unit price for future qty changes
        totalEl.dataset.unitPrice = Math.round((price / qty) * 100);
      }
      if (unitLabel) unitLabel.textContent = qty + ' × ₹' + (price / qty).toFixed(2) + '/pc';
    };

    // ── Tabs ─────────────────────────────────────────────────
    document.querySelectorAll('[data-tab]').forEach(btn => {
      btn.addEventListener('click', () => {
        const tab = btn.dataset.tab;

        document.querySelectorAll('[data-tab]').forEach(b => {
          b.classList.remove('border-b-2', 'border-primary-dark', 'text-primary-dark');
          b.classList.add('border-transparent', 'text-text-light');
        });
        btn.classList.add('border-b-2', 'border-primary-dark', 'text-primary-dark');
        btn.classList.remove('border-transparent', 'text-text-light');

        document.querySelectorAll('[data-tab-panel]').forEach(p => p.classList.add('hidden'));
        const panel = document.querySelector('[data-tab-panel="' + tab + '"]');
        if (panel) panel.classList.remove('hidden');
      });
    });

    // ── Thumbnail selector ───────────────────────────────────
    document.querySelectorAll('[data-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        document.querySelectorAll('[data-thumb]').forEach(t => {
          t.classList.remove('border-primary-dark');
          t.classList.add('border-transparent');
        });
        thumb.classList.add('border-primary-dark');
        thumb.classList.remove('border-transparent');

        const mainImg = document.getElementById('main-product-img');
        const src = thumb.dataset.fullSrc;
        if (mainImg && src) {
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = src;
        }

        const previewOverlay = document.getElementById('engraving-preview-overlay');
        const alt = thumb.dataset.alt || '';
        if (previewOverlay) {
          if (alt.includes('engraving')) {
            previewOverlay.style.display = 'block';
          } else {
            previewOverlay.style.display = 'none';
          }
        }
      });
    });

    // ── Customization Image Switching ────────────────────────
    const engravingCheckbox = document.getElementById('gift-engraving-checkbox');
    const wrapCheckbox = document.getElementById('gift-wrap-checkbox');
    const engravingText = document.getElementById('engraving-text');
    
    function switchToImage(keyword, extraKeyword = '') {
      const thumbs = document.querySelectorAll('[data-thumb]');
      const activeVariantBtn = document.querySelector('[data-variant-btn].bg-primary-dark');
      const variantTitle = activeVariantBtn && activeVariantBtn.dataset.variantTitle ? activeVariantBtn.dataset.variantTitle : '';
      
      let exactMatch = null;
      let extraKeywordMatch = null;
      let variantKeywordMatch = null;
      let justKeywordMatch = null;

      for (let i = 0; i < thumbs.length; i++) {
        const alt = thumbs[i].dataset.alt || '';
        
        if (alt.includes(keyword)) {
          if (!justKeywordMatch) justKeywordMatch = thumbs[i];
          
          const hasVariant = variantTitle && alt.includes(variantTitle);
          const hasExtra = extraKeyword && alt.includes(extraKeyword);

          if (hasVariant) {
            if (!variantKeywordMatch) variantKeywordMatch = thumbs[i];
          }
          if (hasExtra) {
            if (!extraKeywordMatch) extraKeywordMatch = thumbs[i];
          }
          if (hasVariant && hasExtra) {
            if (!exactMatch) exactMatch = thumbs[i];
          }
        }
      }

      // Priority: 1) Match both variant + extra, 2) Match extra, 3) Match variant, 4) Match just keyword
      const matchToClick = exactMatch || extraKeywordMatch || variantKeywordMatch || justKeywordMatch;
      
      if (matchToClick) {
        matchToClick.click();
      }
    }

    if (engravingCheckbox) {
      engravingCheckbox.addEventListener('change', (e) => {
        if (e.target.checked) switchToImage('engraving');
      });
    }
    if (engravingText) {
      engravingText.addEventListener('focus', () => switchToImage('engraving'));
    }
    
    if (wrapCheckbox) {
      wrapCheckbox.addEventListener('change', (e) => {
        if (e.target.checked) {
          const activeRadio = document.querySelector('input[name="ribbon-color"]:checked');
          const color = activeRadio ? activeRadio.value.toLowerCase() : '';
          switchToImage('wrap', color);
        }
      });
    }

    const ribbonRadios = document.querySelectorAll('input[name="ribbon-color"]');
    ribbonRadios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        if (wrapCheckbox && wrapCheckbox.checked) {
          switchToImage('wrap', e.target.value.toLowerCase());
        }
      });
    });

    // ── Add to Cart & Buy Now ──────────────────────────────────────────
    const addBtn = document.getElementById('add-to-cart-btn');
    const buyNowBtn = document.getElementById('buy-now-btn');

    async function handleCartAction(e, isBuyNow) {
      e.preventDefault();
      
      const btn = isBuyNow ? buyNowBtn : addBtn;
      if (!addBtn) return; // we rely on addBtn's dataset for state
      
      const variantId = parseInt(addBtn.dataset.addToCart, 10);
      const qty       = parseInt(addBtn.dataset.qty || '1', 10);
      if (!variantId || btn.disabled) return;

      // ── Customization Logic Validation ──
      const properties = {};
      let validationFailed = false;

      const engravingCheckbox = document.getElementById('gift-engraving-checkbox');
      if (engravingCheckbox && engravingCheckbox.checked) {
        const engTextEl = document.getElementById('engraving-text');
        const engFontEl = document.getElementById('engraving-font');
        if (!engTextEl.value.trim()) {
          const errEl = document.getElementById('engraving-error');
          if (errEl) {
            errEl.textContent = 'Engraving text is required.';
            errEl.classList.remove('hidden');
          }
          validationFailed = true;
        } else {
          properties['Engraving'] = 'Yes';
          properties['Engraving Text'] = engTextEl.value.trim();
          if (engFontEl) properties['Engraving Font'] = engFontEl.value;
        }
      }

      if (validationFailed) return; // Prevent action

      const wrapCheckbox = document.getElementById('gift-wrap-checkbox');
      if (wrapCheckbox && wrapCheckbox.checked) {
        const ribbon = document.querySelector('input[name="ribbon-color"]:checked');
        const note = document.getElementById('gift-note');
        
        properties['Gift Wrap'] = 'Yes';
        if (ribbon) properties['Ribbon'] = ribbon.value;
        if (note && note.value.trim()) properties['Gift Note'] = note.value.trim();
      }

      const originalHTML = btn.innerHTML;
      btn.disabled  = true;
      btn.innerHTML = isBuyNow ? '<span>Redirecting...</span>' : '<span>Adding...</span>';

      try {
        const itemsToCart = [];
        const bundleId = Date.now().toString();

        // Main product
        const mainItem = { id: variantId, quantity: qty };
        if (Object.keys(properties).length > 0) {
          properties['_bundle_id'] = bundleId;
          mainItem.properties = properties;
        }
        itemsToCart.push(mainItem);

        if (Object.keys(properties).length > 0) {
          // Engraving Service
          if (engravingCheckbox && engravingCheckbox.checked) {
            itemsToCart.push({ id: 67610451083375, quantity: qty, properties: { '_bundle_id': bundleId, '_is_addon': 'true' } });
          }

          // Gift Wrap Service
          if (wrapCheckbox && wrapCheckbox.checked) {
            itemsToCart.push({ id: 67610453442671, quantity: qty, properties: { '_bundle_id': bundleId, '_is_addon': 'true' } });
          }
        }

        const res = await fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body:    JSON.stringify({ items: itemsToCart }),
        });

        if (!res.ok) {
          const errData = await res.json().catch(() => ({}));
          throw new Error(errData.description || 'Failed to add item to cart');
        }

        if (isBuyNow) {
          window.location.href = '/checkout';
        } else {
          btn.innerHTML = '<span>Added to Cart!</span>';
          btn.classList.add('bg-forest-green');
          btn.classList.remove('bg-primary-dark');

          // Tell theme.js to refresh the cart drawer contents then open it
          document.dispatchEvent(new CustomEvent('recoco:cart-updated'));
          document.dispatchEvent(new CustomEvent('recoco:open-cart'));

          setTimeout(() => {
            btn.innerHTML = originalHTML;
            btn.disabled  = false;
            btn.classList.remove('bg-forest-green');
            btn.classList.add('bg-primary-dark');
          }, 2000);
        }

      } catch (e) {
        console.error('[Cart Action]', e.message);
        btn.innerHTML = '<span>Error \u2014 try again</span>';
        btn.disabled  = false;
        
        if (!isBuyNow) {
          btn.classList.remove('bg-forest-green');
          btn.classList.add('bg-primary-dark');
        }
        
        setTimeout(() => { btn.innerHTML = originalHTML; }, 2500);
      }
    }

    if (addBtn) addBtn.addEventListener('click', (e) => handleCartAction(e, false));
    if (buyNowBtn) buyNowBtn.addEventListener('click', (e) => handleCartAction(e, true));

    // ── Custom Review Form ──────────────────────────────────
    const toggleReviewBtn = document.getElementById('toggle-review-form-btn');
    const cancelReviewBtn = document.getElementById('cancel-review-btn');
    const reviewForm = document.getElementById('product-review-form');
    
    if (toggleReviewBtn && reviewForm) {
      toggleReviewBtn.addEventListener('click', () => {
        reviewForm.classList.remove('hidden');
        toggleReviewBtn.classList.add('hidden');
      });
      if (cancelReviewBtn) {
        cancelReviewBtn.addEventListener('click', () => {
          reviewForm.classList.add('hidden');
          toggleReviewBtn.classList.remove('hidden');
        });
      }
    }

    const reviewStars = document.getElementById('review-stars');
    const ratingInput = document.getElementById('review-rating-input');
    if (reviewStars && ratingInput) {
      const stars = Array.from(reviewStars.children);
      const updateStars = (val) => {
        stars.forEach((star, idx) => {
          if (idx < val) {
            star.classList.add('text-primary-tan');
            star.classList.remove('text-gray-300');
          } else {
            star.classList.remove('text-primary-tan');
            star.classList.add('text-gray-300');
          }
        });
      };
      stars.forEach((star, idx) => {
        star.addEventListener('mouseover', () => updateStars(idx + 1));
        star.addEventListener('click', () => ratingInput.value = idx + 1);
      });
      reviewStars.addEventListener('mouseleave', () => updateStars(parseInt(ratingInput.value)));
      if (reviewForm) {
        reviewForm.addEventListener('submit', (e) => {
          e.preventDefault();
          const btn = reviewForm.querySelector('button[type="submit"]');
          btn.textContent = 'Submitting...';
          btn.disabled = true;
          setTimeout(() => {
            reviewForm.innerHTML = '<div class="text-center py-6"><svg class="w-12 h-12 text-primary-dark mx-auto mb-3" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"></path></svg><h5 class="text-lg font-medium text-primary-dark">Review Submitted</h5><p class="text-sm text-text-light mt-1">Thank you for your feedback! Your review is pending approval.</p></div>';
          }, 800);
        });
      }
    }

  } // end init()

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
